(function () {
  'use strict';

  var SA_LINK_LABELS = [
    {
      pattern: 'shopperapproved.com/reviews',
      label: 'Read our customer reviews on Shopper Approved'
    },
    {
      pattern: 'youtube.com/user/islandwatchdotcom',
      label: 'Long Island Watch on YouTube'
    }
  ];

  function labelSALinks() {
    SA_LINK_LABELS.forEach(function (rule) {
      var links = document.querySelectorAll('a[href*="' + rule.pattern + '"]');
      for (var i = 0; i < links.length; i++) {
        var link = links[i];
        if (!link.getAttribute('aria-label') && !link.textContent.trim()) {
          link.setAttribute('aria-label', rule.label);
        }
      }
    });
  }

  function initSAFix() {
    labelSALinks();
    new MutationObserver(function () {
      labelSALinks();
    }).observe(document.body, { subtree: true, childList: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSAFix);
  } else {
    initSAFix();
  }

  var CONTAINER_ID = 'klaviyo-container-instagramfeed';
  var FEED_ITEM_SELECTOR = '.crt-carousel-pane';

  function labelFeedItems(root) {
    var panes = root.querySelectorAll(FEED_ITEM_SELECTOR);
    for (var i = 0; i < panes.length; i++) {
      if (panes[i].getAttribute('role') !== 'article') {
        panes[i].setAttribute('role', 'article');
      }
    }
  }

  function syncInert(root) {
    var hidden = root.querySelectorAll('[aria-hidden="true"]');
    for (var i = 0; i < hidden.length; i++) {
      if (!hidden[i].hasAttribute('inert')) hidden[i].setAttribute('inert', '');
    }
    var inerted = root.querySelectorAll('[inert]');
    for (var j = 0; j < inerted.length; j++) {
      if (inerted[j].getAttribute('aria-hidden') !== 'true') {
        inerted[j].removeAttribute('inert');
      }
    }
  }

  function remediate(root) {
    labelFeedItems(root);
    syncInert(root);
  }

  var scheduled = false;
  function schedule(root) {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(function () {
      scheduled = false;
      remediate(root);
    });
  }

  function observe(container) {
    remediate(container);
    new MutationObserver(function () {
      schedule(container);
    }).observe(container, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['aria-hidden', 'class', 'role']
    });
  }

  function init() {
    var container = document.getElementById(CONTAINER_ID);
    if (container) {
      observe(container);
      return;
    }
    var bodyObserver = new MutationObserver(function () {
      var found = document.getElementById(CONTAINER_ID);
      if (found) {
        bodyObserver.disconnect();
        observe(found);
      }
    });
    bodyObserver.observe(document.documentElement, { subtree: true, childList: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
